// const header = document.getElementById("main-header");
const imagesToLoad = document.querySelectorAll( '[data-voomct-background-image]' );

let scroll = window.requestAnimationFrame || function (callback) {
	window.setTimeout(callback, 1000 / 60);
};

// forEach polyfill
if (window.NodeList && !NodeList.prototype.forEach) {
	NodeList.prototype.forEach = Array.prototype.forEach;
}


/**
 *
 *
 *
 */
const init = function () {
	loop();
};


/**
 *
 *
 *
 */
const loop = function () {

	if ( imagesToLoad ) {
		lazyLoadBackgroundImages();
	}

	scroll(loop);
};


/**
 *
 *
 *
 */
const lazyLoadBackgroundImages = function() {

	imagesToLoad.forEach( ( element ) => {

		const imagePath = element.getAttribute('data-voomct-background-image');

		if ( isElementInViewport( element ) && element.style.backgroundImage === '' && imagePath !== '' ) {
			element.style.backgroundImage = 'url('+imagePath+')';
		}

	} );

}


/**
 *
 *
 *
 */
const isElementInViewport = ( el ) => {

	var rect = el.getBoundingClientRect();

	return (
		( rect.top <= 0 && rect.bottom >= 0 )
		||
		( rect.bottom >= ( window.innerHeight || document.documentElement.clientHeight ) && rect.top <= ( window.innerHeight || document.documentElement.clientHeight ) )
		||
		( rect.top >= 0 && rect.bottom <= ( window.innerHeight || document.documentElement.clientHeight ) )
	);

};


const api = {
	init: init
};

export default api;
